import { render } from "./SiteDonations.vue?vue&type=template&id=1bbbba3b"
import script from "./SiteDonations.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteDonations.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SitesDash/manage/SiteDonations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bbbba3b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bbbba3b', __exports__)) {
    api.reload('1bbbba3b', __exports__)
  }
  
  module.hot.accept("./SiteDonations.vue?vue&type=template&id=1bbbba3b", () => {
    api.rerender('1bbbba3b', render)
  })

}


export default __exports__